import _curry2 from "./internal/_curry2";
import mergeDeepWithKey from "./mergeDeepWithKey";
var mergeDeepRight = _curry2(function mergeDeepRight(lObj, rObj) {
    return mergeDeepWithKey(function (_, __, rVal) {
        return rVal;
    }, lObj, rObj);
});
export default mergeDeepRight;
//# sourceMappingURL=mergeDeepRight.js.map